import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VotacionService {

  apiUrl: string = environment.REST_API.URL;
  constructor(private http: HttpClient) { }

  guardar(votacion) {
    return this.http.post(this.apiUrl + "votacion/guardarVotacion", votacion);
  }

  actualizar(votacion) {
    return this.http.put(this.apiUrl + "votacion/actualizarVotacion", votacion);
  }

  obtenerPagina(page: number, size: number) {
    return this.http.get(this.apiUrl + "votacion/obtenerVotaciones?page=" + page + "&size=" + size);
  }

  obtenerPaginaLink(link) {
    return this.http.get(link);
  }

  obtenerPorId(idVotacion: number) {
    return this.http.get(this.apiUrl + "votacion/consultaVotacion?idVotacion=" + idVotacion);
  }

  sellarVotantes(idVotacion: number, usuario: string) {
    return this.http.get(this.apiUrl + "votacion/sellarVotantesVotacion?idVotacion=" + idVotacion + "&usuario=" + usuario);
  }

  sellarBoleta(idVotacion: number, usuario: string) {
    return this.http.get(this.apiUrl + "votacion/sellarBoletaVotacion?idVotacion=" + idVotacion + "&usuario=" + usuario);
  }

  sellarVotacion(idVotacion: number, usuario: string) {
    return this.http.get(this.apiUrl + "votacion/sellarVotacion?idVotacion=" + idVotacion + "&usuario=" + usuario);
  }

  iniciarVotacion(idVotacion: number, usuario: string) {
    return this.http.get(this.apiUrl + "votacion/iniciarVotacion?idVotacion=" + idVotacion + "&usuario=" + usuario);
  }

  finalizarVotacion(idVotacion: number, usuario: string) {
    return this.http.get(this.apiUrl + "votacion/finalizarVotacion?idVotacion=" + idVotacion + "&usuario=" + usuario);
  }

  obtenerVotacionToken(token: string) {
    return this.http.get(this.apiUrl + "votacion/obtenerVotacionToken?token=" + token);
  }

  guardarResultados(resultados) {
    return this.http.post(this.apiUrl + "votacion/guardarResultados", resultados);
  }

  publicarVotacion(idVotacion: number, usuario: string) {
    return this.http.get(this.apiUrl + "votacion/publicarVotacion?idVotacion=" + idVotacion + "&usuario=" + usuario);
  }

  obtenerResultadosVotacionToken(token: string) {
    return this.http.get(this.apiUrl + "votacion/obtenerResultadosVotacionToken?token=" + token);
  }

  obtenerVotos(idVotacion: number) {
    return this.http.get(this.apiUrl + "voto/consultaVotosVotacion?idVotacion=" + idVotacion);
  }

  obtenerVotosProducto(idVotacion: number) {
    return this.http.get(this.apiUrl + "voto/obtenerProductoVotos?idVotacion=" + idVotacion);
  }

  obtenerPaginaVotos(page: number, size: number, token: string, numeroRastreo: string) {
    return this.http.get(this.apiUrl + "voto/obtenerVotosResultadosPaginado?page=" + page + "&size=" + size + "&token=" + token + "&numeroRastreo=" + numeroRastreo);
  }

  obtenerPaginaVotos2(page: number, size: number, idVotacion: number, numeroRastreo: string) {
    return this.http.get(this.apiUrl + "voto/obtenerVotosResultadosPaginado2?page=" + page + "&size=" + size + "&idVotacion=" + idVotacion + "&numeroRastreo=" + numeroRastreo);
  }

}
